import { Outlet } from 'react-router-dom'
import { Header } from './Header'
import { Sidebar } from './Sidebar'
import { useAuth } from '@/hooks'

/**
 * AdminLayout component that wraps all protected admin pages.
 * Provides consistent header, sidebar navigation, and main content area.
 *
 * Layout structure:
 * - Header: Fixed at top with logo, navigation links, user info, and logout
 * - Sidebar: Fixed on left (desktop) or bottom nav (mobile) with navigation
 * - Main: Scrollable content area with proper spacing for fixed elements
 *
 * A1Homes branding is applied through:
 * - Logo with "A1" badge and "A1Homes Admin" text
 * - Consistent use of theme colors from Tailwind config
 * - Professional, clean design aesthetic
 */
export function AdminLayout() {
  const { user, signOut } = useAuth()

  async function handleLogout() {
    await signOut()
  }

  return (
    <div className="min-h-screen bg-background">
      {/* Header - Fixed at top */}
      <Header user={user} onLogout={handleLogout} />

      {/* Sidebar - Fixed on left (desktop) or bottom (mobile) */}
      <Sidebar />

      {/* Main Content Area */}
      <main className="pb-20 md:ml-64 md:pb-0">
        <div className="container py-6 md:py-8">
          <Outlet />
        </div>
      </main>
    </div>
  )
}

export default AdminLayout
